import { Button } from "../../components/ui/button";
import { ModalShell } from "../../components/ui/modal";
import { useLanguage } from "../../hooks/useLanguage";

type DeletePageTriggerProps = {
  visible: boolean;
  onClick: () => void;
};

export function DeletePageTrigger({
  visible,
  onClick,
}: DeletePageTriggerProps) {
  const { t } = useLanguage();

  if (!visible) return null;

  return (
    <div className="pt-2">
      <Button
        type="button"
        variant="destructive"
        className="w-full"
        onClick={onClick}
      >
        {t.pageBuilder.deletePage.deletePageButton}
      </Button>
    </div>
  );
}

type DeletePageModalProps = {
  open: boolean;
  deleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeletePageModal({
  open,
  deleting,
  onCancel,
  onConfirm,
}: DeletePageModalProps) {
  const { t } = useLanguage();

  return (
    <ModalShell
      open={open}
      onClose={() => !deleting && onCancel()}
      disableBackdropClose={deleting}
    >
      <div className="relative w-full rounded-2xl bg-white p-6 shadow-xl">
        <h2 className="text-xl font-semibold mb-2">{t.pageBuilder.deletePage.modalTitle}</h2>
        <p className="text-sm text-neutral-600">
          {t.pageBuilder.deletePage.modalDescription}
        </p>
        <div className="flex justify-end gap-3 pt-6">
          <Button
            type="button"
            variant="ghost"
            disabled={deleting}
            onClick={onCancel}
          >
            {t.pageBuilder.deletePage.cancel}
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={deleting}
            onClick={onConfirm}
          >
            {deleting ? t.pageBuilder.deletePage.deleting : t.pageBuilder.deletePage.confirm}
          </Button>
        </div>
      </div>
    </ModalShell>
  );
}
